class InstallationAccordion extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('[data-accordion-item]'));
    this.allowMultiple = this.dataset.allowMultiple === 'true';

    this.items.forEach((item) => {
      const trigger = item.querySelector('[data-accordion-trigger]');
      const panel = item.querySelector('[data-accordion-panel]');

      if (!trigger || !panel) return;

      trigger.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');

        if (!this.allowMultiple) {
          this.items.forEach((otherItem) => {
            if (otherItem !== item) {
              this.closeItem(otherItem);
            }
          });
        }

        if (isOpen) {
          this.closeItem(item);
        } else {
          this.openItem(item);
        }
      });
    });

    if (this.dataset.openFirst === 'true' && this.items[0]) {
      this.openItem(this.items[0], false);
    }
  }

  openItem(item, animate = true) {
    const trigger = item.querySelector('[data-accordion-trigger]');
    const panel = item.querySelector('[data-accordion-panel]');

    panel?.removeAttribute('hidden');
    trigger?.setAttribute('aria-expanded', 'true');

    if (animate) {
      requestAnimationFrame(() => {
        item.classList.add('is-open');
      });
    } else {
      item.classList.add('is-open');
    }
  }

  closeItem(item) {
    const trigger = item.querySelector('[data-accordion-trigger]');
    const panel = item.querySelector('[data-accordion-panel]');

    item.classList.remove('is-open');
    trigger?.setAttribute('aria-expanded', 'false');

    if (!panel) return;

    const handleTransitionEnd = (event) => {
      if (event.target !== panel || event.propertyName !== 'grid-template-rows') return;
      panel.setAttribute('hidden', '');
      panel.removeEventListener('transitionend', handleTransitionEnd);
    };

    panel.addEventListener('transitionend', handleTransitionEnd);
  }
}

customElements.define('installation-accordion', InstallationAccordion);
